import { withTabItems } from '../common/RoutableTabContainer';
import CSSettledTransactionList from './CSSettledTransactionList';
import CSPendingTransactionList from './CSPendingTransactionList';
import CSMoneyStatementList from './CSMoneyStatementList';
import CSReportList from './CSReportList';

export default withTabItems([
  {
    label: 'Pending Txn',
    url: 'pending-transactions',
    comp: CSPendingTransactionList,
    tooltip: 'MT537. Pending Transactions',
  },
  {
    label: 'Settled Txn',
    url: 'settled-transactions',
    comp: CSSettledTransactionList,
    tooltip: 'MT536. Settled Transactions',
  },
  {
    label: 'Money Statement',
    url: 'money-statement',
    comp: CSMoneyStatementList,
    tooltip: 'MT950. Money Statement',
  },
  {
    label: '! Reports',
    url: 'reports',
    comp: CSReportList,
  },
], () => 'CS Activity \u2022 ');
